import {API} from "@/middlewares/api";
import {createAsyncThunk} from "@reduxjs/toolkit";

export const loadAllHealthProgrammes = createAsyncThunk(
  "healthProgrammes/loadAllHealthProgrammes",
  async (_, thunkAPI) => {
    try {
      const response = await API("secure/coach-programmes");

      return thunkAPI.fulfillWithValue(response);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const activateHealthProgramme = createAsyncThunk(
  "healthProgrammes/activateHealthProgramme",
  async (name, thunkAPI) => {
    try {
      const response = await API(`secure/signup-programme/${name}`);

      return thunkAPI.fulfillWithValue(response);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const checkPost = createAsyncThunk("healthProgrammes/checkPost", async (payload, thunkAPI) => {
  try {
    const response = await API("secure/check-post", {method: "POST", body: payload});

    return thunkAPI.fulfillWithValue(response);
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

export const updatePostRating = createAsyncThunk("healthProgrammes/updatePostRating", async (payload, thunkAPI) => {
  try {
    const response = await API("secure/update-likes", {method: "POST", body: payload});

    return thunkAPI.fulfillWithValue(response);
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});
